import { IWinLevel } from '@GFTypes/GameStoreTypes/WinLevels';

export const WIN_LEVELS_CONFIGURATION_DEFAULTS: IWinLevel[] = [];
